module.exports = __webpack_public_path__ + "img/lighting.dd8c4a56.jpeg";